"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Forms/FormTextMessage.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _forms = require('shared/services/forms');
var _selectBlobjectByWrappedKey = require('shared/selectors/blobject/common/selectBlobjectByWrappedKey');
var _selectMyOrgKeyInConvo = require('shared/selectors/conversation/selectMyOrgKeyInConvo');
var _features = require('shared/selectors/org/features');

var _hooks = require('web/services/hooks');
var _TextMessage = require('web/components/Conversation/Message/TextMessage'); var _TextMessage2 = _interopRequireDefault(_TextMessage);
var _FormCard = require('./FormCard'); var _FormCard2 = _interopRequireDefault(_FormCard);



/* The chat's org when it is a patient chat in an org with Forms, else null. */
 const useFormsChatOrg = (conversationKey) => _hooks.useAppSelector.call(void 0, state => {
  const blobject = _selectBlobjectByWrappedKey.selectBlobjectByWrappedKey.call(void 0, state, conversationKey)
  if (!blobject || blobject.WrappedType === 'chat') return null
  const orgKey = _selectMyOrgKeyInConvo.selectMyOrgKeyInConvo.call(void 0, state, blobject.Key)
  return orgKey && _features.selectOrgHasForms.call(void 0, state, orgKey) ? orgKey : null
}); exports.useFormsChatOrg = useFormsChatOrg

/* A text holding a staff form link: its caption, then the form's card. Out
 * of a patient chat, with Forms off, or for a code the server doesn't know in
 * this chat, it is the plain text it always was. */
const FormTextMessage = ({ code, ...props }) => {
  const orgKey = exports.useFormsChatOrg.call(void 0, props.conversationKey)
  const status = _forms.useFormStatus.call(void 0, props.deleted ? null : orgKey, props.conversationKey, code)
  const caption = _react.useMemo.call(void 0, () => _forms.textWithoutFormLink.call(void 0, props.text), [props.text])
  const card = _react.useMemo.call(void 0, 
    () => orgKey && status !== null ? _react2.default.createElement(_FormCard2.default, { code: code, conversationKey: props.conversationKey, card: status, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}} ) : null,
    [code, orgKey, status, props.conversationKey],
  )
  if (!card || props.deleted) return _react2.default.createElement(_TextMessage2.default, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}} )
  return _react2.default.createElement(_TextMessage2.default, { ...props, text: caption, attachment: card, __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}} )
}

exports. default = FormTextMessage
